import React from 'react';
import { RightMenu, RightMenuItem } from '@shakkerai/pro-components';
import { useRightMenuState } from '../../store/base';
import { useGenHistoryItemEventHooks } from '../../hooks/eventHooks.js';
import { useClickOutside } from '@mantine/hooks';
import { translate } from '@shakkerai/util-i18n';

const menuRectWidth = 180;

export const RightMenuWrapper = (props) => {
  const { containerRef, source } = props;
  const { rightMenuVisible, closeRightMenu, menuTop, menuLeft, currentVisitItem } = useRightMenuState();
  const rect = containerRef?.current?.getBoundingClientRect();

  const ref = useClickOutside(closeRightMenu);

  let showOnLeft = false; // 判断右边屏幕空间是否不足
  if (window.innerWidth - menuLeft < menuRectWidth) {
    showOnLeft = true;
  }

  const { onImport, onAddAsReference, onCopyPrompt, onAddToCanvas } = useGenHistoryItemEventHooks({
    itemInfo: currentVisitItem,
    source,
  });

  return (
    <RightMenu
      ref={ref}
      visible={rightMenuVisible}
      style={{
        width: menuRectWidth,
        top: menuTop - rect?.top,
        left: showOnLeft ? menuLeft - rect?.left - menuRectWidth : menuLeft - rect?.left,
        position: 'fixed',
        zIndex: 1,
      }}
    >
      <RightMenuItem
        data-role="gen-history-trigger"
        onClick={() => {
          onImport();
          closeRightMenu();
        }}
      >
        {translate('history_regenerate')}
      </RightMenuItem>
      <RightMenuItem
        data-role="gen-history-trigger"
        onClick={() => {
          onAddAsReference();
          closeRightMenu();
        }}
      >
        {translate('history_ref')}
      </RightMenuItem>
      <RightMenuItem
        data-role="gen-history-trigger"
        onClick={() => {
          onAddToCanvas();
          closeRightMenu();
        }}
      >
        {translate('history_movetocanva')}
      </RightMenuItem>
      <RightMenuItem
        data-role="gen-history-trigger"
        onClick={() => {
          onCopyPrompt();
          closeRightMenu();
        }}
      >
        {translate('copy_prompt')}
      </RightMenuItem>
    </RightMenu>
  );
};
